const similariesTableHeader = [
  '',
  'Typologie',
  'S.bien',
  'S.terrain',
  'Ville',
  'Origine',
  'Prix',
  'Activité',
  'Dossier',
];

const areaMarkerUrl = '/images/marker-icon-yellow.png';
const dpeMarkerUrl = '/images/marker-icon-cyan.png';
const dpeAreaMarkerUrl = '/images/marker-icon-green.png';
const dpeCombinedMarkerUrl = '/images/marker-icon-red.png';

export {
  areaMarkerUrl,
  dpeAreaMarkerUrl,
  dpeMarkerUrl,
  dpeCombinedMarkerUrl,
  similariesTableHeader,
};
